import type { ObjectActionHandlers } from "@/object-actions/types";
import { useMemo } from "react";

export interface SkillTemplateActionHandlerDeps {
  addToMySkills: () => void;
  /** Only wired when the current user may unpublish (publisher / org admin). */
  unpublish?: () => void;
}

/** Registry handlers for a Skills-rail template row. */
export function useSkillTemplateObjectActionHandlers(
  deps: SkillTemplateActionHandlerDeps,
): ObjectActionHandlers {
  return useMemo(
    (): ObjectActionHandlers => ({
      "add-to-my-skills": () => window.setTimeout(deps.addToMySkills, 0),
      unpublish: deps.unpublish
        ? () => window.setTimeout(() => deps.unpublish?.(), 0)
        : undefined,
    }),
    [deps],
  );
}
